import { applySnippet, extendOverUnpairedClosingBrace } from "./apply.js";
import { documentCommands } from "../document-commands.js";
import { syntaxTree } from "@codemirror/language";
const commandNameFromLabel = (label) => label.match(/^\\\w+/)?.[0];
export function customCommandCompletions(context, commandCompletions) {
    const existingCommands = new Set(
        commandCompletions.map((item) => commandNameFromLabel(item.label)).filter(Boolean),
    );
    const output = [];
    const items = countCommandUsage(context);
    for (const item of items.values()) {
        if (!existingCommands.has(commandNameFromLabel(item.label)) && !item.ignoreInAutoComplete) {
            output.push({
                type: "cmd",
                label: item.label,
                boost: Math.max(0, item.count - 10),
                apply: applySnippet(item.snippet),
                extend: extendOverUnpairedClosingBrace,
            });
        }
    }
    return commandCompletions.concat(output);
}
const countCommandUsage = (context) => {
    const tree = syntaxTree(context.state);
    const currentNode = tree.resolveInner(context.pos, -1);
    const result = new Map();
    const commandListProjection = context.state.field(documentCommands);
    if (!commandListProjection.items) {
        return result;
    }
    for (const command of commandListProjection.items) {
        if (command.from === currentNode.from) {
            continue;
        }
        const label = buildLabel(command);
        const snippet = buildSnippet(command);
        const item = result.get(label) || {
            label,
            snippet,
            count: 0,
            ignoreInAutoComplete: command.ignoreInAutocomplete,
        };
        item.count++;
        result.set(label, item);
    }
    return result;
};
const buildLabel = (command) => {
    return [
        `${command.title}`,
        "[]".repeat(command.optionalArgCount ?? 0),
        "{}".repeat(command.requiredArgCount ?? 0),
    ].join("");
};
const buildSnippet = (command) => {
    return [
        `${command.title}`,
        "[#{}]".repeat(command.optionalArgCount ?? 0),
        "{#{}}".repeat(command.requiredArgCount ?? 0),
    ].join("");
};
